import { Link, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { useState, useEffect } from "react";

export default function Header() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => { setOpen(false); }, [location.pathname, setOpen]);

  const navItems = [
    { to: "/", label: "Kezdőlap" },
    { to: "/termek", label: "Termék" },
    { to: "/funkciok", label: "Jellemzők" },
    { to: "/kapcsolat", label: "Kapcsolat" },
  ];

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#031a20]/85 border-b border-[#d4af37]/15"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-baseline gap-2">
          <span className="font-serif text-2xl tracking-tight text-white">SolarSimple</span>
          <span className="text-[10px] tracking-[0.3em] uppercase text-[#d4af37]">Pergola</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {navItems.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to.replace("/", "") || "home"}`}
              className={`text-xs uppercase tracking-[0.2em] transition-colors ${
                location.pathname === n.to
                  ? "text-[#d4af37]"
                  : "text-white/70 hover:text-[#d4af37]"
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <button
          className="md:hidden p-2"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
        >
          <Menu className="w-5 h-5 text-white" />
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#031a20]">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-4">
            {navItems.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`mobile-nav-${n.to.replace("/", "") || "home"}`}
                className="text-sm uppercase tracking-[0.2em] text-white"
              >
                {n.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
